
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"576","viewBox":"0 -87 432 432","width":"576","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M278.906 0H30C13.437.02.02 13.438 0 30v197.422c.02 16.562 13.438 29.98 30 30h248.906c16.559-.02 29.98-13.438 30-30V30c-.02-16.563-13.441-29.98-30-30zm0 0M328.906 169.8L432 226.087V31.98L328.906 88.266zm0 0"}})])
          )
        }
      }
    